import { connect } from 'react-redux';
// Don't be tempted to use any other stuff from the page store here. It can cause a code red.
// If you want access to that stuff, try modules/react/hooks/useCurrentPageData
import { getPageFacility } from 'store/modules/page';
import { getSite } from 'store/modules/site';
import CurrentPageServerProvider from 'website/components/stateless/CurrentPageServerProvider';

const mapStateToProps = state => ({
  currentSite: getSite(state),
  facility: getPageFacility(state),
});

export default connect(
  mapStateToProps,
)(CurrentPageServerProvider);
